import { IVehicle } from 'components/SearchBlock/CarSearch/CarSearchBlock';

export interface ILicencePlateVehicle {
    manuId: string;
    manuName: string;
    modId: string;
    modelName: string;
    carId: string;
    typeTitle: string;
    year?: string;
    displacement?: string;
    power?: string;
    engineCode?: string;
    nextCheck?: string;
}

const mapVehicle = (car: ILicencePlateVehicle, licence?: string): IVehicle => ({
    manufacturer: {
        id: car.manuId,
        label: car.manuName,
    },
    model: {
        id: car.modId,
        label: car.modelName,
    },
    type: {
        id: car.carId,
        label: car.typeTitle,
    },
    licence,
    year: car.year || undefined,
    displacement: car.displacement || undefined,
    power: car.power || undefined,
    engineCode: car.engineCode || undefined,
    nextCheck: car.nextCheck || undefined,
});

export default mapVehicle;
